<template>
  <div>
    <div oncontextmenu="return false" class="card d-print-none qp-card-view" style="padding-right: 15px;">
    <!-- <div class="card qp-card-view" style="padding-right: 15px;"> -->
      <div class="card-header qp-card-header">
        <div class="qp-btn-area w-100">
          <a href="/" class="d-inline-block" style="width:80px;float:left;">
            <img style="width: 100%" alt="Eduwhere logo" src="//static.eduwhere.in/PRODUCTION/images/logo.png">
          </a>
          <div class="d-none d-sm-inline-block" style="padding-left: 8px;float:left;width:calc(100% - 80px);">
            <div class="qp-header-action">
              <span id="attempt-mode-text" v-if="attemptMode == 'practice'" class="text-uppercase font-weight-bold">Attempt mode</span>
              <span id="attempt-mode-text" v-if="attemptMode == 'solution'" class="text-uppercase font-weight-bold">Solution mode</span>
              <button type="button" v-if="attemptMode == 'practice'" style="margin-left: 2px;" class="quit-question-practice-set-btn float-right" @click="onQuit()" >Quit</button>
              <button type="button" 
                v-if="attemptMode == 'practice'" 
                class="set-question-submit-attempt float-right" 
                :class="currentAttemptData.id && ( currentQuestionIndex()+1 == currentAttemptData.question_count ) ? 'enabled-btn': 'disabled-btn'"
                style="display: inline-block;" 
                @click="submitAttempt( $event )" 
                >Submit
              </button>

              <button type="button" 
                v-if="attemptMode == 'solution'" 
                class="set-question-submit-attempt enabled-btn float-right" 
                style="display: inline-block;" 
                @click="goToResultPage()"
                >&laquo; Back to Results
              </button>
            </div>
            <h4 class="qp-card-title">Attempt set{{ currentAttemptData && currentAttemptData.id ? ( '-' + currentAttemptData.set_counter): ''}}
              <h6 v-if="currentAttemptData && currentAttemptData.id">Subject:&nbsp;{{currentAttemptData.subject_name}}, Total questions:&nbsp;{{currentAttemptData.question_count}}</h6>
            </h4>
          </div>
          <div class="d-sm-none d-inline-block" style="font-size: 14px;padding-left: 8px;float:left;width:calc(100% - 80px);">
            <div class="qp-header-action">
              <span id="attempt-mode-text" v-if="attemptMode == 'practice'" class="text-uppercase font-weight-bold">Attempt mode</span>
              <span id="attempt-mode-text" v-if="attemptMode == 'solution'" class="text-uppercase font-weight-bold">Solution mode</span>
              <button type="button" v-if="attemptMode == 'practice'" style="margin-left: 2px;" class="quit-question-practice-set-btn float-right" @click="onQuit()" ><i class="fa fa-sign-out" aria-hidden="true"></i></button>
              <button type="button" 
                v-if="attemptMode == 'practice'" 
                class="set-question-submit-attempt float-right" 
                :class="currentAttemptData.id && ( currentQuestionIndex()+1 == currentAttemptData.question_count ) ? 'enabled-btn': 'disabled-btn'"
                style="display: inline-block;" 
                @click="submitAttempt( $event )" 
                ><i class="fa fa-paper-plane" aria-hidden="true"></i>
              </button>
              <button type="button" 
                v-if="attemptMode == 'solution'" 
                class="set-question-submit-attempt enabled-btn float-right" 
                style="display: inline-block;" 
                @click="goToResultPage()"
                >&laquo; Results
              </button>
            </div>
            <h4 class="qp-card-title">Attempt set{{ currentAttemptData && currentAttemptData.id ? ( '-' + currentAttemptData.set_counter): ''}}
              <h6 v-if="currentAttemptData && currentAttemptData.id">Subject:&nbsp;{{currentAttemptData.subject_name}}, Total questions:&nbsp;{{currentAttemptData.question_count}}</h6>
            </h4>
          </div>
        </div>
      </div>
      <div class="card-body qp-card-body">
        <div class="set-practice-overlay" v-if="showOverlay">
          <img src="https://static.eduwhere.in/PRODUCTION/images/preloader_495_64x64.gif" height="64" width="64" alt="">
        </div>
        <div class="alert alert-danger fade in alert-dismissible show set-fetch-alert" v-if="errorMessage">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="closeError()">
            <span aria-hidden="true" style="font-size:20px">×</span>
          </button>
          <span id="error-message">{{errorMessage}}</span>
        </div>
        <div v-if="currentAttemptData && currentAttemptData.id" class="set-attempt-card" style="">
          <div class="row">
            <div class="col-12 d-none d-md-block navigation-bar">
              <a href="#" class="offset-md-10 col-md-1 prev-direction" :class="getNavClass('prev')" @click.stop.prevent="prevQuestion()">«</a>
              <a href="#" class="col-md-1 next-direction" :class="getNavClass('next')" @click.stop.prevent="nextQuestion()">»</a>
            </div>
          </div>
          <div class="progress" style="height: 1.5rem;font-size: 1rem;">
            <div class="progress-bar text-center font-weight-bold pl-2 bg-success" id="question-attempt-progress-bar" :style="'width: '+getProressBar()+'%;'">{{currentQuestionIndex()+1}}/{{currentAttemptData.question_count}}</div>
          </div>
          <div id="question-card-carousel-wrapper" v-if="setData && setData.id"  class="row">
            <div class="question-choices-card owl-carousel" id="question-choices-card-carousel">
              <div 
                class="card qcards" 
                v-for="( id, index ) in setData.question_ids" 
                :data-index="String(index)" 
                :data-question-id="id" 
                :id="'question-card-index-'+index" style="border: none;"
              >
                <div class="card-header">
                  <span>Q.-{{currentQuestionIndex()+1}}:</span>&nbsp;
                  <span v-if="(attemptMode == 'solution') && questionData[ id ] && ( questionData[ id ].status == 1 )" class="badge badge-success" style="font-size: inherit;background-color: #03bb91;">Correct Answer</span>
                  <span v-if="( attemptMode == 'solution' ) && questionData[ id ] && ( questionData[ id ].status == -1 )" class="badge badge-danger" style="font-size: inherit;background-color: #f44336;">Wrong Answer</span>
                  <span v-if="( attemptMode == 'solution' ) && questionData[ id ] && ( !questionData[ id ].status )" class="badge badge-warning" style="font-size: inherit;">Skipped Answer</span>
                  <div v-html="(questionData[ id ] ? questionData[ id ].question: '')"></div>
                </div>
                <div class="card-body set-question-sol-div" v-if="attemptMode == 'solution'">
                  <div class="card-title col-12" style="padding-top: 6px;padding-left: 0;">
                    <span class="qp-solution-label"> Solution </span>
                  </div>
                  <div id="set-solution" class="solution-content" v-html="questionData[ current_question_id ]? questionData[ current_question_id ].solution: ''">
                  </div>
                </div>
                <div v-if="attemptMode == 'practice'" class="col-12 mt-1" style="font-size: 14px;"><button  @click.stop.prevent="removeAnswer()" type="button" class="qp-clear-answer text-uppercase btn btn-success rounded-0 float-left" style="">Clear Answer</button></div>
                <div class="card-body" :data-question-id="id">
                  <div class="list-group" v-if="questionData[ id ]">
                    <div 
                      v-if="questionData[ id ].correct_answer_type == 'multiple'"  
                      v-for="( choice, index ) in questionData[ id ].answer_choices" 
                      class="list-group-item list-group-item-action mb-1 form-check set-choice-input-div" 
                      style="padding-left: 2rem;"  
                      @click="supportBoxClick( $event )"
                      >
                      <label class="form-check-label qp-option-label">
                        <input class="form-check-input" type="checkbox" name="answer_choice[]" 
                        :value="String(index)" 
                        :id="'option'+index" 
                        :checked="isChoiceMarked( questionData[ id ], index )"
                        @click="onAnswerChange( $event )"
                        >
                        <div v-html="choice"></div>
                        <div v-if="attemptMode=='solution'">
                          <span v-if="isCorrect(index)" class="ew_set_correct_option" style="border-radius: 3px;background: #03bb91;color: #fff;font-weight: 600;padding: 1px 7px;font-size: 13px;">  &#10003; Correct </span>
                          <span v-if="isWrong(index)" class="ew_set_wrong_option" style="border-radius: 3px;background: #f44336;color: #fff;font-weight: 600;padding: 1px 7px;font-size: 13px;">  x Wrong </span>
                        </div>
                      </label>
                    </div>
                     <div 
                      v-else 
                      class="list-group-item list-group-item-action mb-1 form-check set-choice-input-div" 
                      style="padding-left: 2rem;" 
                      @click="supportBoxClick( $event )"
                      >
                      <label class="form-check-label qp-option-label">
                        <input class="form-check-input" type="radio" name="answer_choice" 
                        :value="String(index)" 
                        :id="'option'+index" 
                        :checked="isChoiceMarked( questionData[ id ], index )" 
                        @click="onAnswerChange( $event )"
                        > 
                        <div v-html="choice"></div>
                        <div v-if="attemptMode=='solution'">
                          <span v-if="isCorrect(index)" class="ew_set_correct_option" style="border-radius: 3px;background: #03bb91;color: #fff;font-weight: 600;padding: 1px 7px;font-size: 13px;">  &#10003; Correct </span>
                          <span v-if="isWrong(index)" class="ew_set_wrong_option" style="border-radius: 3px;background: #f44336;color: #fff;font-weight: 600;padding: 1px 7px;font-size: 13px;">  x Wrong </span>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer p-0 border-0 qp-card-footer">
        <div class="btn-toolbar row" role="toolbar">
          <div class="btn-group col-12 w-100 float-left text-center" style="">
            <a href="#" class="col-6 prev-direction" :class="getNavClass('prev')" @click.stop.prevent="prevQuestion()">«</a>
            <a href="#" class="col-6 next-direction" :class="getNavClass('next')" @click.stop.prevent="nextQuestion()">»</a>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div 
        oncontextmenu="return false" 
        id="set-question-image-modal" 
        data-backdrop="static" 
        class="modal fade set-image-preview-modal d-print-none"
        :class="image_preview ? 'show d-block': ''" 
      >
        <div class="set-image-preview-header">
          <span class="set-image-preview-close" @click="image_preview=false">&times;</span>
        </div>
        <div class="set-image-preview-body">
          <img class="modal-content set-image-preview-img" :src="current_img_src" id="set-image-preview">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  export default {

    data () {
      return {
        isAuthenticated: false,
        showOverlay: false,
        examSlug: this.$route.params.examSlug,
        setId: this.$route.params.setId,
        attemptMode: this.$route.params.attemptMode,
        attemptId: this.$route.params.attemptId,
        errorTimeout: false,
        currentAttemptData: {},
        setData: {},
        questionCarousel: "",
        previous_question_id: false,
        current_question_id: false,
        questionData: {},
		    questionIds: [],
        tapedTwice: false,
        navigation_enabled: false,
        image_preview: false,
        current_img_src: "",
        question_time_interval: false,
        errorMessage: false
      }
    },

    created() {

      this.resetData();
      this.checkAuth();
    },

    watch: {

      image_preview( newValue, oldValue ) {

        if( newValue ) {
          this.navigation_enabled = false;
          // enable pinch zoom
          this.$nextTick( ()=> {

            new PinchZoom.default($(".set-image-preview-img")[0], {});
          });
          return;
        }
        this.navigation_enabled = true;
        window.location.hash = window.location.hash.split("-image_")[0];
      }
    },

    beforeDestroy() {

      this.unBindEvents();
      this.setData = {};
      $(window).unbind('hashchange').unbind( 'beforeunload' ).unbind( 'unload' );
      this.resetData();
    },

    methods: {

      resetData() {

        this.isAuthenticated = false;
        this.currentAttemptData = {};
        // this.setData = {};
        this.showOverlay = false;
        this.questionCarousel = "";
        this.previous_question_id =  false;
        this.current_question_id = false;
        this.questionData = {};
        this.questionIds = [];
        this.tapedTwice = false;
        this.navigation_enabled = false;
        this.image_preview = false;
        this.current_img_src = "";
        if ( this.question_time_interval ) {

          clearInterval(this.question_time_interval);
        }
        if( this.errorTimeout ) {

          clearTimeout( this.errorTimeout );
        }
        this.question_time_interval = false;
        this.errorTimeout = false;
      },

      isCorrect(index) {
        let curentQData = this.questionData[ this.current_question_id ];
        
        return ( curentQData && curentQData.correct_answers[index]  ) ? true: false;
      },

      isWrong(index) {
        let curentQData = this.questionData[ this.current_question_id ];

        if( !curentQData ) {

          return false;
        }

        if( !( curentQData.correct_answers[index] ) ) {

          if( curentQData.answer_choice_index.indexOf( index ) != -1 ) {

            return true;
          }
        }
        
        
        return false;
      },

      onAnswerChange( evt ) {

        if( this.attemptMode != "practice") {
          
          evt.preventDefault();
          return;
        }

        const currentQuestionCardId = `question-card-index-${this.currentQuestionIndex()}`;

        let curentQData = this.questionData[ this.current_question_id ];

        curentQData.answer_choice_index = [];

        $('#'+ currentQuestionCardId + ' input:radio[name="answer_choice"]:checked').each(function(index, item){

          curentQData.answer_choice_index.push( parseInt( $( item ).val( ) ) );
        });

        $('#'+ currentQuestionCardId + ' input:checkbox[name="answer_choice[]"]:checked').each(function(index, item){

          curentQData.answer_choice_index.push( parseInt( $( item ).val( ) ) );
        });

        this.questionData[ this.current_question_id ] = curentQData;
        this.$forceUpdate();
        if( evt ) {

          $(evt.target).blur();
        }
      },

      removeAnswer( e ) {

        if( this.attemptMode != "practice" ) return;

        const currentQuestionCardId = `question-card-index-${this.currentQuestionIndex()}`;
        $('#'+ currentQuestionCardId + ' input:radio[name="answer_choice"]:checked').each( function(index, item ){

          $( this ).prop( 'checked', false );
        });
        $('#'+ currentQuestionCardId + ' input:checkbox[name="answer_choice[]"]:checked').each( function(index, item ){

          $( this ).prop( 'checked', false );
        });
        this.onAnswerChange();
      },

      supportBoxClick( e ) {

        if( this.attemptMode != "practice") {

          return;
        }

        if( $(e.target).parents(".qp-option-label").length || $(e.target).hasClass("qp-option-label") ) {

          return;
        }
        $( $(e.target).find(".form-check-input:radio[name='answer_choice']")[0] ).prop("checked", true).trigger('click');
        $( $(e.target).find(".form-check-input:checkbox[name='answer_choice[]']")[0] ).trigger('click');
      },

      onKeyBoardNav( evt ) {

        if( !this.navigation_enabled ) {

          return;          
        }

        switch( evt.keyCode ) {

          case 37:
            this.prevQuestion();
          break;
          case 39:
            this.nextQuestion();
          break;
        }
      },

      bindDelayedEvents() {

        this.$nextTick( ()=> {
          MathJax.Hub.Queue(["Typeset",MathJax.Hub]);
          MathJax.Hub.Queue(()=>{
            this.bindDbClickEventForImagePreview();
            this.addScrollToQuestionCard();
          });
        });
      },

      getNavClass( direction ) {

        let classname = "enabled-btn"

        if( ( this.currentQuestionIndex() == 0 ) && ( direction == "prev") ) {

          classname = "disabled-btn";
        }

        if( ( this.currentQuestionIndex() == ( this.questionIds.length -1 ) ) && ( direction == "next") ) {

          classname = "disabled-btn";
        }
        return classname;
      },

      currentQuestionIndex() {

        if( this.questionIds && this.questionIds.length && this.current_question_id ) {

          return this.questionIds.findIndex( id=> id.toString() == this.current_question_id.toString() );
        }
        return -1;
      },

      hasNextQuestion() {

        const totalQ = this.questionIds.length;

        if( this.currentQuestionIndex() < ( totalQ-1 ) ) {

          return true;
        }
        return false;
      },

      hasPrevQuestion() {

        const totalQ = this.questionIds.length;

        if( this.currentQuestionIndex() > 0 ) {

          return true;
        }
        return false;
      },

      nextQuestion() {

        if( this.hasNextQuestion() ) {

          const qId = this.questionIds[ this.currentQuestionIndex() + 1 ];
          this.changeHash( qId );
        }
      },

      prevQuestion() {

        if( this.hasPrevQuestion() ) {

          const qId = this.questionIds[ this.currentQuestionIndex() - 1 ];
          this.changeHash( qId );
        }
      },

      getProressBar() {

        return ( ( this.currentQuestionIndex() + 1 ) / ( this.questionIds.length ) ) * 100;
      },

      goToEwHome() {

        window.location.href = "/";
      },

      addScrollToQuestionCard() {

        setTimeout( ()=> {

          $("#question-card-carousel-wrapper-css").remove();
          $('#question-card-carousel-wrapper').append(

            '<style type="text/css" id="question-card-carousel-wrapper-css">'+
              '#question-card-carousel-wrapper {'+
                'height: calc(100% - '+ ( $(window).width() > 767 ? (0+178) : (48+139) ) +'px);'+
                'overflow-y: auto;'+
                  'position: fixed;'+
                  'width: 100%;'+
              '}'+
            '</style>'
          );
          this.initScrollToTop();
        }, 300 );
      },

      initScrollToTop() {

          $("#qp_ew_movetop_block").remove();
          $("#question-card-carousel-wrapper").prepend(

            '<div id="qp_ew_movetop_block">'+
            '<a href="javascript:;" class="qp_ew_movetop">^</a>'+
            '<style type="text/css">'+
              '.qp_ew_movetop {'+
                'bottom: 55px;'+
                'right: 2%;'+
                'display: none;'+
                'height: 45px;'+
                'width: 42px;'+
                'font-size: 30px;'+
                'line-height: 53px;'+
                'position: fixed;'+
                'text-align: center;'+
                'z-index: 99;'+
                'background: #363636;'+
                'background: rgba(100,100,100,.6);'+
                'color: #fff;'+
                '-webkit-transition: background-color .3s linear;'+
                '-moz-transition: background-color .3s linear;'+
                '-o-transition: background-color .3s linear;'+
                'transition: background-color .3s linear;'+
              '}'+

                '.qp_ew_movetop:hover, .qp_ew_movetop:focus {'+
                   'background-color: #363636;'+
                   'opacity: .8;'+
                '}'+
            '</style>'+
          '</div>'
          );

        $(".qp_ew_movetop").unbind("click").bind("click", function() {

          $('#question-card-carousel-wrapper').animate({ scrollTop: 0 }, 'slow', function () {});
        });
        $('#question-card-carousel-wrapper').unbind('scroll').bind( 'scroll', function() {
          var y = $(this).scrollTop();

          if ( y > 20 ) {

            $('.qp_ew_movetop').fadeIn();
          } else {

            $('.qp_ew_movetop').fadeOut();
          }
        });
      },

      bindDbClickEventForImagePreview() {

        $(".question-choices-card img").unbind('dblclick').bind('dblclick', this.changeToImageHash );
        /* To find out its double tap*/
        this.tapedTwice = false;
        $(".question-choices-card img").unbind('touchstart').bind('touchstart',( e )=> {

          if(!this.tapedTwice) {
              this.tapedTwice = true;
              setTimeout( function() {
                this.tapedTwice = false;
              }, 300 );
          } else {

            this.changeToImageHash(e);
            this.tapedTwice = false;
          }
        } );
      },

      changeToImageHash( e ) {

        var imageIndex = $(".question-choices-card .owl-item.active img").index( e.currentTarget );
        e.preventDefault();
        
        if( imageIndex != -1 ) {

          window.location.hash = window.location.hash + '-'+ 'image_'+ imageIndex;
        }
      },

      checkAuth() {

        axios.get(`/ajax/check-auth`).then((response)=> {

          if( !response.data.status ) {

            return this.handleError( response.data.error.message, response.data.error );
          }

          if( response.data.status && response.data.isAuthenticated ) {

            this.isAuthenticated = true;
            this.getCurrentSet();
            return;
          }

          this.$parent.sendToLogin( `/quick-practice/exam/${this.examSlug}/set/${this.setId}` );
        }).catch((error) =>{
          return this.handleError( "Something went wrong!!" );
        }).finally(()=> {});
      },

      closeError() {
        this.errorMessage = false;
        this.$forceUpdate();
      },

      handleError( message, error ) {

        this.showOverlay = false;
        this.errorMessage = message;
        this.$parent.logoutIfInvalidToken( error );
        this.errorTimeout = setTimeout(()=> {
          
          this.errorMessage = false;
          this.$forceUpdate();
        }, 5000 );
      },

      isChoiceMarked( currentQ, index ) {

        if( currentQ.answer_choice_index && currentQ.answer_choice_index.length ) {
                      
          if( currentQ.answer_choice_index.indexOf( index ) != -1 ) {

            return true;
          }
        }
        return false;
      },

      getCurrentSet() {

        this.showOverlay = true;
        axios.get(`/ajax/question-set/${this.setId}`).then((response)=> {

          if( !response.data.status ) {

            return this.handleError( response.data.error.message, response.data.error );
          }

          this.setData = response.data.data;
          
          if( this.attemptMode == "solution") {

            this.getAttemptResult();
          }
          if( this.attemptMode == "practice") {
           this.getAttemptProgress(); 
          }
        }).catch((error) =>{
          return this.handleError( "Something went wrong!!" );
        }).finally(()=> {

          this.showOverlay = false;
        });
      },
      
      getAttemptResult() {

        this.showOverlay = true;
        axios.get(`/ajax/question-set/attempt/${this.attemptId}/result`).then( (response)=> {

          if( !response.data.status ) {

            window.location.href = `${window.location.origin}/quick-practice/exam/${this.examSlug}/set/${this.setId}`;
            return;
          }

          this.currentAttemptData = response.data.data;
          if( this.currentAttemptData.set_id != this.setId ) {

            window.location.href = `${window.location.origin}/quick-practice/exam/${this.examSlug}/set/${this.setId}`;
            return;
          }

          this.questionIds = this.setData.question_ids;
          this.$forceUpdate();
          setTimeout(()=>this.addQuestionCarousel(), 200 );
        }).catch((error) =>{
          return this.handleError( "Something went wrong!!" );
        }).finally(()=> {

          this.showOverlay = false;
        });
      },

      getAttemptProgress() {

        this.showOverlay = true;
        axios.get(`/ajax/question-set/attempt/${this.attemptId}/progress`).then((response)=> {

          if( !response.data.status ) {

            window.location.href = `${window.location.origin}/quick-practice/exam/${this.examSlug}/set/${this.setId}`;
            return;
          }

          this.currentAttemptData = response.data.data;
          if( this.currentAttemptData.set_id != this.setId ) {

            window.location.href = `${window.location.origin}/quick-practice/exam/${this.examSlug}/set/${this.setId}`;
            return;
          }

          this.questionIds = this.setData.question_ids;
          this.$forceUpdate();
          setTimeout(()=>this.addQuestionCarousel(), 200 );
        }).catch((error) =>{
          return this.handleError( "Something went wrong!!" );
        }).finally(()=> {

          this.showOverlay = false;
        });
      },
  
      changeHash( question ) {

        if( this.questionIds &&  ( this.questionIds.indexOf( question ) != -1 ) ) {

          window.location.hash = question;
        }
      },

      checkUrlAndLoadQuestion() {

        this.previous_question_id = this.current_question_id;
        const hashStr = window.location.hash.substr(1);
        const hash = hashStr.split('-');
        const question_id = hash[0], image_hash = hash[1];
        if( !this.questionIds || !this.questionIds.length ) {

          return;
        }

        if( image_hash && image_hash.indexOf('image_') != -1 ) {

          const imgIndex = image_hash.split('image_')[1];
          
          const current_image_index = Number(imgIndex) || 0;
          const current_img = $(".question-choices-card .owl-item.active img")[current_image_index];
        
          if( !current_img ) {

            window.location.hash = window.location.hash.split("-image_")[0];
            return;
          }
          // show preview
          this.current_img_src = $(current_img).attr("src");
          this.image_preview = true;
          return;
        }

        if( this.image_preview && !image_hash ) {

          // close preview
          this.image_preview = false;
          this.current_img_src = "";
          return;
        }

        if( !question_id ) {

          this.changeHash( this.questionIds[0]);
          return;
        }

        this.current_question_id = question_id;
        this.questionCarousel.trigger( 'owl.goTo', this.questionIds.indexOf( question_id ) );
        this.loadCurrentQuestion();
      },

      onLoadCurrentQuestion() {

        this.showOverlay = false;
        this.bindDelayedEvents();
        this.trackQuestionTime();

        if( this.attemptMode == "practice" && this.previous_question_id ) {

          this.syncQuestionData( this.previous_question_id, null );
        }
      },

      loadCurrentQuestion() {

        this.showOverlay = true;
        const { attemptMode, current_question_id, currentAttemptData } = this;

        if( this.questionData.hasOwnProperty( current_question_id ) ) {

          this.onLoadCurrentQuestion();
          return;
        }
            
        const urlToGetQuestion = ( attemptMode == "solution" ) ? `/ajax/question-set/attempt/${this.currentAttemptData.id }/question/${this.current_question_id}/solution`: `/ajax/question-set/${this.setData.id}/question/${current_question_id}`;

        axios.get( urlToGetQuestion ).then((response)=> {

          if( !response.data.status ) {

            return this.handleError( response.data.error.message, response.data.error );
          }

          let currentQData = response.data.data;

          // check if question is in current attempt data 
          const questionInAttempt = currentAttemptData.questions.find( question => current_question_id.toString() == question.question_id.toString() );

          if( attemptMode == "practice" ) {

            currentQData.time_taken_in_ms = 0;
            if( questionInAttempt ) {

              if( questionInAttempt.hasOwnProperty('status') ) {

                if( questionInAttempt.is_submitted ) {

                  currentQData.is_submitted = true;
                  currentQData.correct_answers = questionInAttempt.correct_answers;
                  currentQData.solution = questionInAttempt.solution;
                  currentQData.answer_choice_index = questionInAttempt.answer_choice_index;
                } else {

                  currentQData.is_submitted = false;
                }
              }

              currentQData.time_taken_in_ms = questionInAttempt.time_taken_in_ms;
            }
          }

          if( attemptMode == "solution" ) {

            currentQData.is_submitted = true;
            currentQData.answer_choice_index = questionInAttempt ? questionInAttempt.answer_choice_index : [];
            currentQData.time_taken_in_ms = questionInAttempt ? questionInAttempt.time_taken_in_ms: 0;
            currentQData.status = questionInAttempt && questionInAttempt.status ? questionInAttempt.status : 0;
          }

          // in some questions there are more choices as when no of choices changes after choices added
          currentQData.answer_choices = currentQData.answer_choices.slice( 0, currentQData.answer_choice_count );

          let questionData = this.questionData;
          questionData[ current_question_id ] = currentQData;
          this.questionData = questionData;
          this.$forceUpdate();
          this.onLoadCurrentQuestion();
        }).catch((error) =>this.handleError( "Something went wrong!!" )).finally(()=> {

          this.showOverlay = false;
        });
      },

      addQuestionCarousel() {

        this.questionCarousel = $(".question-choices-card").owlCarousel({

          singleItem: true,
          navigation: false,
          pagination: false,
          addClassActive: true,
          slideSpeed : 250,
          afterMove: ( e )=> {

            const owlItemActiveIndex = $(".question-choices-card .owl-item.active .qcards").attr("data-index");

            $('#question-card-carousel-wrapper').animate({ scrollTop: 0 }, 'slow',()=> {});
            // case when crousal work on swipe only slide change not hash so change hash
            if(  owlItemActiveIndex != this.currentQuestionIndex() ) {
					    this.changeHash(  this.questionIds[ owlItemActiveIndex ] );
            }
          }
        });

        this.bindEvents();
        $(window).unbind('hashchange').bind('hashchange', this.checkUrlAndLoadQuestion );

        const hashStr = window.location.hash.substr(1);
        const question_id = hashStr.split('-')[0];

        if( question_id && this.questionIds.find( ( id )=> id.toString() == question_id.toString() ) ) {

          $(window).trigger('hashchange');
          return;
        }

        if( this.attemptMode == "solution" ) {

          this.changeHash( this.questionIds[0] );
          return;
        } 

        const qIdToResume = ( this.currentAttemptData && this.currentAttemptData.questions.length  ) ? this.currentAttemptData.questions[ this.currentAttemptData.questions.length - 1 ].question_id: this.questionIds[0];
        this.changeHash( qIdToResume );
      },

      trackQuestionTime() {

        if( this.question_time_interval ) {

          clearInterval( this.question_time_interval );
          this.question_time_interval = false;
        }

        if( this.attemptMode == 'practice' ) {

          this.question_time_interval = setInterval( ()=> {

            if ( this.questionData.hasOwnProperty( this.current_question_id ) ) {

              this.questionData[ this.current_question_id].time_taken_in_ms += 100;
            }
          }, 100);
        }
      },

      syncQuestionData( question_id, callback ) {

        if ( this.attemptMode == 'solution' ) return;

        let qData = this.questionData[ question_id ];
        if( qData.answer_choice_index &&  Array.isArray( qData.answer_choice_index ) &&  qData.answer_choice_index.length
        ) {
          // to mark choice if choose and moved
          qData.status = 1;
        }

        axios.post( `/ajax/question-set/attempt/${this.currentAttemptData.id}/sync`, {

          attempt_id: this.currentAttemptData.id,
          question: qData
        }).then((response)=> {

          if ( response.data.status == false ) {

            this.handleError( response.data.error.message, response.data.error );
            if( response.error.code == 46004 ) {

              $(window).unbind('hashchange').unbind( 'beforeunload' ).unbind( 'unload' );
              this.$router.push({  path: `/quick-practice/exam/${this.examSlug}/set/` });
            }
            return;
          }
          if (typeof(callback)=='function'){
            setTimeout( ()=>callback( response ), 100);
          }
        }).catch((error)=> {

          setTimeout(()=>this.syncQuestionData( question_id ), 2000)
        }).finally(()=> {});
      },

      goToResultPage( is_not_submitted ) {

        $(window).unbind('hashchange').unbind( 'beforeunload' ).unbind( 'unload' );
        this.$router.push({  path: `/quick-practice/${this.setData.slug}/${ is_not_submitted ?  'practice-more': 'result'}/${this.setData.id}/${this.attemptId}` });
      },

      onQuit() {

        this.$parent.trackEvent( `${this.setData.exam_slug}-question-set`, this.setData.subject_slug, "quit-attempt" );

        if( this.attemptMode !== "practice" ) {

          this.resetData();
          this.goToResultPage();
          return;
        }
  
        if( confirm("Are you sure you want to quit?") ) {
          if( this.current_question_id ) {

            this.syncQuestionData( this.current_question_id, ()=> {
              
              this.resetData();
              this.goToResultPage( true );
            } );
          } else {
            this.resetData();
            this.goToResultPage( true );
          }
        }
      },

      submitAttempt( e ) {

        if($( e.target ).hasClass("disabled-btn")) return;

        this.$parent.trackEvent( `${this.setData.exam_slug}-question-set`, this.setData.subject_slug, "submit-attempt" );
        
        if( confirm("Are you sure you want to submit?") ) {

          this.showOverlay = true;
          this.syncQuestionData( this.current_question_id, ()=> {

            axios.post( `/ajax/question-set/attempt/${this.currentAttemptData.id}/submit`, {}).then((response)=> {
        
              if ( response.data.status == false ) {
      
                this.handleError( "Error in submitting data.", response.data.error );
                return;
              }
              this.resetData();
              this.goToResultPage();
            }).catch((error)=> this.handleError( "Error in submitting data." )).finally(()=> { this.showOverlay = false});
          });
        }
      },

      syncOnUnload() {
        
        if( 
          this.attemptMode == "practice" && 
          this.current_question_id && 
          this.questionData[ this.current_question_id ] 
        ) {
          console.log("on unload!")
          this.syncQuestionData( this.current_question_id );
        }
      },

      bindEvents() {

        this.navigation_enabled = true;
        window.addEventListener('keyup', this.onKeyBoardNav );

        if( this.attemptMode == "solution") {

          return;
        }

        $(window).bind( 'beforeunload',()=> {

          this.syncOnUnload();

          return 'You are about to leave this page. It may loss your local data.';
        } ).bind( 'unload',()=> {

          //  this.syncOnUnload();
        } );
      },

      unBindEvents() {

        window.removeEventListener('keyup', this.onKeyBoardNav );
        $(window).unbind( 'beforeunload' ).unbind( 'unload' );
      },
    }
  }
</script>

<style scoped>
  @media only screen and (max-width: 767px) {
    .qp-card-footer {
      display: block !important;
    }
    .qp-card-body {
      height: calc(100% - 148px);
    }
  }

  .navigation-bar a {
    background: #e1b606;
    display: inline-block;
    border: 1px solid #2b2b2b;
    font-size: 25px;
    font-weight: 600;
    color: #333;
    text-align: center;
  }
  .navigation-bar a:hover {
    text-decoration: none !important;
  }
  .navigation-bar a.disabled-btn {
    background: #3e3e3e;
    color: #fff;
    pointer-events: none;
    cursor: default;
  }
  .set-image-preview-modal {
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden !important;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.9);
  }

  .set-image-preview-img {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
  }

  .set-image-preview-header {
    height: 60px;
    width: 100%;
  }

  .set-image-preview-body {
    height: calc(100% - 60px);
    overflow-y: auto;
    width: 100%;
  }

  .set-image-preview-close {
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
    float: right;
    margin-right: 3%;
    margin-top: 3px;
  }

  .set-image-preview-close:hover,
  .set-image-preview-close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
  }

  .qp-solution-label {
    background: #0C1621;
    color: #fff;
    font-weight: bold;
    padding: 2px 12px;
    text-transform: uppercase;
    font-size: 11px;
    border-bottom: 4px solid #03BB91;
  }

  .solution-content {

    border-bottom: 1px solid #e9ecef;
    width: 100%;
  }

  @media only screen and (max-width: 700px) {
    .set-image-preview-img {
      width: 100%;
    }
  }
</style>
